import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {AccountTypeEntityModel} from "../account-type-entity.model";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {ChangeDetectorRef, Component} from "@angular/core";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-account-type-edit-page",
    templateUrl: "./account-type-edit-page.component.html",
    providers: [(provideEntityModel(AccountTypeEntityModel))]
})
export class AccountTypeEditPageComponent extends AbstractEditPage {
    constructor(public model: AccountTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
